module.exports = __webpack_public_path__ + "img/highlights4-s.53e9e01b.png";